import { ArrowLeft, Phone, MoreVertical } from 'lucide-react'
import { motion, AnimatePresence } from 'motion/react'
import { useState } from 'react'
import Avatar from '../ui/Avatar'

interface Props {
  name: string
  isGroup?: boolean
  memberCount?: number
  typingUsers: string[]
  onBack: () => void
}

export default function ChatHeader({ name, isGroup, memberCount, typingUsers, onBack }: Props) {
  const [showMenu, setShowMenu] = useState(false)

  return (
    <header className="chat-header glass">
      <button onClick={onBack} className="back-btn"><ArrowLeft size={22} /></button>
      <Avatar name={name} size={38} className="ch-avatar" />
      <div className="chat-info">
        <h2 className="chat-name">{name}</h2>
        <p className="chat-status">
          {typingUsers.length > 0 ? (
            <span className="typing">{typingUsers[0]} typing...</span>
          ) : isGroup ? `${memberCount || 0} members` : 'Online'}
        </p>
      </div>
      <button className="icon-btn"><Phone size={18} /></button>
      <div className="relative">
        <button className="icon-btn" onClick={() => setShowMenu(!showMenu)}><MoreVertical size={18} /></button>
        <AnimatePresence>
          {showMenu && (
            <motion.div initial={{ opacity: 0, scale: 0.9 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.9 }} className="dropdown">
              <div className="dd-item">View Profile</div>
              <div className="dd-item">Search Messages</div>
              <div className="dd-item">Mute Notifications</div>
              <div className="dd-item danger">Block User</div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </header>
  )
}
